import styled from '@emotion/styled';
import { ProjectId, ProjectIssueCommentId, ProjectIssueId } from '@kaizenplatform/hugot-entity';
import { createElement, FC, useEffect, useState } from 'react';

import { ProjectDetailsForShowFragment } from '../../../../generated/graphql';
import { PASSED_INSPECTION_CREATION_STATE } from '../../../../graphql/creation';
import ProjectIssueComments from './ProjectIssueComments';
import ProjectIssueForm from './ProjectIssueForm';

interface Props {
  project: ProjectDetailsForShowFragment;
  className?: string;
  onSubmitProjectIssue: (projectId: ProjectId, inputComment: string) => Promise<void>;
  onSubmitProjectIssueComment: (issueId: ProjectIssueId, comment: string) => void;
  onUpdateProjectIssueComment: (commentId: ProjectIssueCommentId, comment: string) => void;
  onDeleteProjectIssueComment: (commentId: ProjectIssueCommentId) => void;
}

const ProjectIssue: FC<Props> = ({
  project,
  className,
  onSubmitProjectIssue,
  onSubmitProjectIssueComment,
  onUpdateProjectIssueComment,
  onDeleteProjectIssueComment,
}) => {
  const [passedInspection, setPassedInspection] = useState(false);

  useEffect(() => {
    let flag = true;
    project.creationSet?.creations?.forEach((c) => {
      if (flag && c.state != undefined && PASSED_INSPECTION_CREATION_STATE.includes(c.state)) {
        setPassedInspection(true);
      } else {
        flag = false;
        setPassedInspection(false);
      }
    });
  }, [project]);

  return (
    <Root className={className} id={'issue.id'}>
      {project.issue ? (
        <ProjectIssueComments
          projectId={project.id}
          orgId={project.organization.id}
          issue={project.issue}
          passedInspection={passedInspection}
          onUpdateProjectIssueComment={onUpdateProjectIssueComment}
          onDeleteProjectIssueComment={onDeleteProjectIssueComment}
        />
      ) : null}
      <ProjectIssueForm
        project={project}
        passedInspection={passedInspection}
        onSubmitProjectIssue={onSubmitProjectIssue}
        onSubmitProjectIssueComment={onSubmitProjectIssueComment}
      />
    </Root>
  );
};

const Root = styled('div')({});

export default ProjectIssue;
